import { type SearchSuggestion } from '@/api/v4/search.api';
import { SuggestionContainer } from './suggestion-container';
import { SuggestionContent } from './suggestion-content';
import { Stack } from '@/ui/line/line';
import { FileContentCell } from './file-suggestions-table/file-content-cell';

export const FileSuggestion = ({
  onClick,
  suggestion,
  isSelected,
  highlights,
}: {
  onClick?: () => void;
  isSelected: boolean;
  highlights?: string[];
  suggestion: SearchSuggestion;
}) => {
  return (
    <SuggestionContainer
      id={suggestion.id}
      onClick={onClick}
      label={suggestion.name}
      isSelected={isSelected}
    >
      <SuggestionContent
        name={suggestion.name}
        type={suggestion.type}
        highlights={highlights}
        contentComponent={
          <Stack>
            <FileContentCell
              content={suggestion.content}
              highlights={suggestion.highlights.fileContent}
            />
          </Stack>
        }
      />
    </SuggestionContainer>
  );
};
